import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconCollaboratorsRestricted = ({ className = '', color = '#979797', height = 16, title, width = 16 }: Icon) => (
    <AccessibleSVG
        className={`icon-collaborators-restricted ${className}`}
        height={height}
        title={title}
        viewBox="0 0 16 16"
        width={width}
    >
        <g className="fill-color" fill={color}>
            <path d="M1.7 3.9l.7.7c-.5 1-.9 2.2-.9 3.4 0 3.6 2.9 6.5 6.5 6.5 1.2 0 2.4-.3 3.3-.9l.7.7c-1.2.8-2.6 1.2-4.1 1.2C3.8 15.5.4 12.1.4 8c.1-1.5.6-2.9 1.3-4.1zM1.8 2.4l12 12c.2.2.5.2.7 0 .2-.2.2-.5 0-.7l-.8-.8c1.1-1.3 1.8-3 1.8-4.9C15.5 3.9 12.1.5 8 .5c-1.9 0-3.6.7-4.9 1.8l-.6-.6c-.2-.2-.5-.2-.7 0s-.2.5 0 .7zM13 12.2l-.7-.7c.1-.2.2-.4.2-.5 0-.7-1-1.1-2-1.3L9.1 8.3c.8-.4 1.4-1.3 1.4-2.3 0-1.4-1.1-2.5-2.5-2.5-1 0-1.8.6-2.2 1.5l-2-2C5 2.1 6.4 1.5 8 1.5c3.6 0 6.5 2.9 6.5 6.5 0 1.6-.6 3-1.5 4.2zM8 4.5c.8 0 1.5.7 1.5 1.5 0 .7-.5 1.4-1.3 1.5L6.6 5.8c.1-.8.7-1.3 1.4-1.3z" />
            <path d="M8 12.5h.1c.6 0 1.2-.2 1.7-.4l.7.7c-.7.4-1.6.7-2.5.7h-.1c-2.3-.1-4.4-1.7-4.5-2.5 0-.2 0-.4.2-.6.6-.6 2.5-.8 3.6-.9l1 1h-.3c-1.3 0-3 .2-3.4.5.5.4 1.8 1.4 3.5 1.5z" />
        </g>
    </AccessibleSVG>
);

export default IconCollaboratorsRestricted;
